import { Module } from 'vuex';
import mutations from './mutations';
import getters from './getters';
import actions from './actions';
import createState from './state';
import { NotificationsState } from './types';

const notificationsModule: Module<NotificationsState, any> = {
  namespaced: true,
  state: createState,
  mutations,
  getters,
  actions,
};

export default notificationsModule;

// Export types
export type { NotificationsState, NotificationData, NotificationType } from './types';

